import { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const DEFAULT_DATE_TYPE = 'datetime';

export const useUrlDateType = (defaultValue = DEFAULT_DATE_TYPE) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [dateType, setDateType] = useState(() => searchParams.get('dateType') || defaultValue);

  useEffect(() => {
    const urlDateType = searchParams.get('dateType') || defaultValue;
    setDateType((current) => (current === urlDateType ? current : urlDateType));
  }, [searchParams, defaultValue]);

  const handleDateTypeChange = useCallback((value) => {
    const nextDateType = value || defaultValue;
    setDateType(nextDateType);

    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('dateType', nextDateType);
    setSearchParams(nextParams, { replace: true });
  }, [searchParams, setSearchParams, defaultValue]);

  return [dateType, handleDateTypeChange];
};
